// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Pervasives = require("bs-platform/lib/js/pervasives.js");

function toClassName(color) {
  switch (color) {
    case /* Orange */0 :
        return "orange";
    case /* Purple */1 :
        return "purple";
    case /* Yellow */2 :
        return "yellow";
    case /* Grey */3 :
        return "grey";
    case /* Pink */4 :
        return "pink";
    case /* Blue */5 :
        return "blue";
    
  }
}

var a = {
  sound: "a",
  image: "",
  color: /* Orange */0,
  side: /* Front */0
};

var m = {
  sound: "m",
  image: "",
  color: /* Orange */0,
  side: /* Front */0
};

var s = {
  sound: "s",
  image: "",
  color: /* Orange */0,
  side: /* Front */0
};

var d = {
  sound: "d",
  image: "",
  color: /* Orange */0,
  side: /* Front */0
};

var t = {
  sound: "t",
  image: "",
  color: /* Orange */0,
  side: /* Front */0
};

var orange_001 = /* :: */[
  m,
  /* :: */[
    s,
    /* :: */[
      d,
      /* :: */[
        t,
        /* [] */0
      ]
    ]
  ]
];

var orange = /* :: */[
  a,
  orange_001
];

var i = {
  sound: "i",
  image: "",
  color: /* Purple */1,
  side: /* Front */0
};

var n = {
  sound: "n",
  image: "",
  color: /* Purple */1,
  side: /* Front */0
};

var p = {
  sound: "p",
  image: "",
  color: /* Purple */1,
  side: /* Front */0
};

var g = {
  sound: "g",
  image: "",
  color: /* Purple */1,
  side: /* Front */0
};

var o = {
  sound: "o",
  image: "",
  color: /* Purple */1,
  side: /* Front */0
};

var purple_001 = /* :: */[
  n,
  /* :: */[
    p,
    /* :: */[
      g,
      /* :: */[
        o,
        /* [] */0
      ]
    ]
  ]
];

var purple = /* :: */[
  i,
  purple_001
];

var c = {
  sound: "c",
  image: "",
  color: /* Yellow */2,
  side: /* Front */0
};

var k = {
  sound: "k",
  image: "",
  color: /* Yellow */2,
  side: /* Front */0
};

var u = {
  sound: "u",
  image: "",
  color: /* Yellow */2,
  side: /* Front */0
};

var b = {
  sound: "b",
  image: "",
  color: /* Yellow */2,
  side: /* Front */0
};

var yellow_001 = /* :: */[
  k,
  /* :: */[
    u,
    /* :: */[
      b,
      /* [] */0
    ]
  ]
];

var yellow = /* :: */[
  c,
  yellow_001
];

var f = {
  sound: "f",
  image: "",
  color: /* Grey */3,
  side: /* Front */0
};

var e = {
  sound: "e",
  image: "",
  color: /* Grey */3,
  side: /* Front */0
};

var l = {
  sound: "l",
  image: "",
  color: /* Grey */3,
  side: /* Front */0
};

var h = {
  sound: "h",
  image: "",
  color: /* Grey */3,
  side: /* Front */0
};

var sh = {
  sound: "sh",
  image: "",
  color: /* Grey */3,
  side: /* Front */0
};

var grey_001 = /* :: */[
  e,
  /* :: */[
    l,
    /* :: */[
      h,
      /* :: */[
        sh,
        /* [] */0
      ]
    ]
  ]
];

var grey = /* :: */[
  f,
  grey_001
];

var r = {
  sound: "r",
  image: "",
  color: /* Pink */4,
  side: /* Front */0
};

var j = {
  sound: "j",
  image: "",
  color: /* Pink */4,
  side: /* Front */0
};

var v = {
  sound: "v",
  image: "",
  color: /* Pink */4,
  side: /* Front */0
};

var y = {
  sound: "y",
  image: "",
  color: /* Pink */4,
  side: /* Front */0
};

var w = {
  sound: "w",
  image: "",
  color: /* Pink */4,
  side: /* Front */0
};

var pink_001 = /* :: */[
  j,
  /* :: */[
    v,
    /* :: */[
      y,
      /* :: */[
        w,
        /* [] */0
      ]
    ]
  ]
];

var pink = /* :: */[
  r,
  pink_001
];

var th = {
  sound: "th",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var z = {
  sound: "z",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var ch = {
  sound: "ch",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var ck = {
  sound: "ck",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var qu = {
  sound: "qu",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var x = {
  sound: "x",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var ng = {
  sound: "ng",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var nk = {
  sound: "nk",
  image: "",
  color: /* Blue */5,
  side: /* Front */0
};

var blue_001 = /* :: */[
  z,
  /* :: */[
    ch,
    /* :: */[
      ck,
      /* :: */[
        qu,
        /* :: */[
          x,
          /* :: */[
            ng,
            /* :: */[
              nk,
              /* [] */0
            ]
          ]
        ]
      ]
    ]
  ]
];

var blue = /* :: */[
  th,
  blue_001
];

var phonemes = Pervasives.$at(orange, Pervasives.$at(purple, Pervasives.$at(yellow, Pervasives.$at(grey, Pervasives.$at(pink, blue)))));

function toString(phoneme) {
  return phoneme.sound;
}

function fromString(sound) {
  switch (sound) {
    case "a" :
        return a;
    case "b" :
        return b;
    case "c" :
        return c;
    case "ch" :
        return ch;
    case "ck" :
        return ck;
    case "d" :
        return d;
    case "e" :
        return e;
    case "f" :
        return f;
    case "g" :
        return g;
    case "h" :
        return h;
    case "i" :
        return i;
    case "j" :
        return j;
    case "k" :
        return k;
    case "l" :
        return l;
    case "m" :
        return m;
    case "n" :
        return n;
    case "ng" :
        return ng;
    case "nk" :
        return nk;
    case "o" :
        return o;
    case "p" :
        return p;
    case "qu" :
        return qu;
    case "r" :
        return r;
    case "s" :
        return s;
    case "sh" :
        return sh;
    case "t" :
        return t;
    case "th" :
        return th;
    case "u" :
        return u;
    case "v" :
        return v;
    case "w" :
        return w;
    case "x" :
        return x;
    case "y" :
        return y;
    case "z" :
        return z;
    default:
      return ;
  }
}

function str(prim) {
  return prim;
}

function Phoneme(Props) {
  var phoneme = Props.phoneme;
  var onClickOpt = Props.onClick;
  var onClick = onClickOpt !== undefined ? onClickOpt : (function (param) {
        return /* () */0;
      });
  return React.createElement("div", {
              className: "phoneme " + toClassName(phoneme.color),
              onClick: (function (_evt) {
                  return Curry._1(onClick, /* () */0);
                })
            }, phoneme.sound);
}

var make = Phoneme;

exports.toClassName = toClassName;
exports.a = a;
exports.m = m;
exports.s = s;
exports.d = d;
exports.t = t;
exports.orange = orange;
exports.i = i;
exports.n = n;
exports.p = p;
exports.g = g;
exports.o = o;
exports.purple = purple;
exports.c = c;
exports.k = k;
exports.u = u;
exports.b = b;
exports.yellow = yellow;
exports.f = f;
exports.e = e;
exports.l = l;
exports.h = h;
exports.sh = sh;
exports.grey = grey;
exports.r = r;
exports.j = j;
exports.v = v;
exports.y = y;
exports.w = w;
exports.pink = pink;
exports.th = th;
exports.z = z;
exports.ch = ch;
exports.ck = ck;
exports.qu = qu;
exports.x = x;
exports.ng = ng;
exports.nk = nk;
exports.blue = blue;
exports.phonemes = phonemes;
exports.toString = toString;
exports.fromString = fromString;
exports.str = str;
exports.make = make;
/* phonemes Not a pure module */
